export const SET_SIMULATOR_LIST_REQUEST = "SET_SIMULATOR_LIST_REQUEST";
export const SET_SIMULATOR_LIST_SUCCESS = "SET_SIMULATOR_LIST_SUCCESS";
export const SET_SIMULATOR_LIST_ERROR = "SET_SIMULATOR_LIST_ERROR";

export const SET_MODEL_LIST_REQUEST = "SET_MODEL_LIST_REQUEST";
export const SET_MODEL_LIST_SUCCESS = "SET_MODEL_LIST_SUCCESS";
export const SET_MODEL_LIST_ERROR = "SET_MODEL_LIST_ERROR";

export const SET_MODEL_VERSION_LIST_REQUEST = "SET_MODEL_VERSION_LIST_REQUEST";
export const SET_MODEL_VERSION_LIST_SUCCESS = "SET_MODEL_VERSION_LIST_SUCCESS";
export const SET_MODEL_VERSION_LIST_ERROR = "SET_MODEL_VERSION_LIST_ERROR";

export const SET_FEATURE_LIST_REQUEST = "SET_FEATURE_LIST_REQUEST";
export const SET_FEATURE_LIST_SUCCESS = "SET_FEATURE_LIST_SUCCESS";
export const SET_FEATURE_LIST_ERROR = "SET_FEATURE_LIST_ERROR";

export const SET_BASE_SCENARIO_LIST_REQUEST = "SET_BASE_SCENARIO_LIST_REQUEST";
export const SET_BASE_SCENARIO_LIST_SUCCESS = "SET_BASE_SCENARIO_LIST_SUCCESS";
export const SET_BASE_SCENARIO_LIST_ERROR = "SET_BASE_SCENARIO_LIST_ERROR";

export const SET_VARIATION_LIST_REQUEST = "SET_VARIATION_LIST_REQUEST";
export const SET_VARIATION_LIST_SUCCESS = "SET_VARIATION_LIST_SUCCESS";
export const SET_VARIATION_LIST_ERROR = "SET_VARIATION_LIST_ERROR";

//----------------------------------------------------------------------------
export const SET_PAYLOAD_LIST_REQUEST = "SET_PAYLOAD_LIST_REQUEST";
export const SET_PAYLOAD_LIST_SUCCESS = "SET_PAYLOAD_LIST_SUCCESS";
export const SET_PAYLOAD_LIST_ERROR = "SET_PAYLOAD_LIST_ERROR";
//--------------------------------------------------------------------------------

//---------------------------------yas-----------------------------------
export const SET_SITUATION2_LIST_REQUEST = "SET_SITUATION2_LIST_REQUEST";
export const SET_SITUATION2_LIST_SUCCESS = "SET_SITUATION2_LIST_SUCCESS";
export const SET_SITUATION2_LIST_ERROR = "SET_SITUATION2_LIST_ERROR";


export const BASE_SCENARIO_SELECTED = "BASE_SCENARIO_SELECTED";

//-----------------------------------------delete------------------------------------------------
 
export const DELETE_SCENARIO_ERROR = "DELETE_SCENARIO_ERROR";
export const DELETE_SCENARIO_REQUEST = "DELETE_SCENARIO_REQUEST";
export const DELETE_SCENARIO_SUCCESS = "DELETE_SCENARIO_SUCCESS ";